import { NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
@Component({
  selector: 'app-workofart-card',
  templateUrl: './workofart-card.component.html',
  styleUrls: ['./workofart-card.component.css'],
  standalone: true,
  imports: [NgOptimizedImage],
})
export class WorkofartCardComponent implements OnInit {
  @Input() item: any;
  @Input() isModal = false; // si es modal, no se muestra el botón de ver más
  @Output() workOfArtClick = new EventEmitter<any>();
  loadedImages = new Set<string>();

  constructor(private router: Router) {}

  ngOnInit() {}

  openWorkOfArtModal(workOfArt: any) {
    // Emitir el evento para el componente padre
    if (this.isModal) {
      this.workOfArtClick.emit(workOfArt);
    } else {
      this.router.navigate([], {
        queryParams: { workOfArtId: workOfArt._id },
        queryParamsHandling: 'merge', // merge with existing query params
        replaceUrl: true,
      });
    }
    // // Mantener la navegación original como fallback
  }
  onThumbnailLoad(id: string) {
    this.loadedImages.add(id);
  }
}
